import { addressMapper, booleanMapper, defaultMapper, geoMapper, priceMapper, rangeMapper } from './mappers';
import { EAnswerType, EQuestionType } from '../../../types/form';
import { EAnswerField } from '../../../repositories/lead-realtor-form/entities/question/QuestionSchema';
import { areaFixedMapper } from './mappers/areaMapper';
import { listMapper } from './mappers/listMapper';

export const getDefaultMapper = (answerType: EAnswerType) => {
  switch (answerType) {
    case EAnswerType.Bool:
      return booleanMapper;
    case EAnswerType.IntEnumList:
      return listMapper;
    case EAnswerType.Range:
      return rangeMapper;
    case EAnswerType.IntEnum:
    case EAnswerType.Integer:
    case EAnswerType.Enum:
    case EAnswerType.String:
    default:
      return defaultMapper;
  }
};
export const getMapper = (questionType: EQuestionType, answerType: EAnswerType, answerField: EAnswerField) => {
  if (answerField === EAnswerField.Area && questionType === EQuestionType.Number) {
    return areaFixedMapper;
  }
  switch (questionType) {
    case EQuestionType.Address:
      return addressMapper;
    case EQuestionType.GeoSuggest:
      return geoMapper;
    case EQuestionType.Price:
      return priceMapper;
    case EQuestionType.Range:
      return rangeMapper;
    default:
      return getDefaultMapper(answerType);
  }
};
